'use strict';

import React, {Component} from 'react';
import {observer} from "mobx-react";
import PropTypes from 'prop-types';
import classnames from "classnames";

import Button from "react-bootstrap/Button";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import Spinner from "react-bootstrap/Spinner";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";

import {States} from "@uw-it-sis/lib-react/lib/AppConstants";
import TermUtils from "@uw-it-sis/lib-react/lib/TermUtils";

import SubscriptionFormStore from "./SubscriptionFormStore";
import profileStore from "./ProfileStore";
import EndpointCheckbox from "./EndpointCheckbox";

class SubscriptionForm extends Component {

    constructor(props) {
        super(props);

        this.props = props;
        this.store = new SubscriptionFormStore();
        this.handleUpdateNotification = this.handleUpdateNotification.bind(this);
    }

    componentDidMount() {
        this.store.mount(this.props.subscription);
    }

    componentWillUnmount() {
        this.store.unmount();
    }

    updateProtocol(e) {
        e.stopPropagation();
        this.store.toggleFormValue(e.target.name);
    }

    handleUpdateNotification(e) {
        e.preventDefault();
        // allow action as long as one protocol is checked
        if (!this.store.isUpdateDisabled()) {
            this.store.saveChanges();
        }
    }

    render() {
        const isPending = this.store.state === States.pending;
        const termId = TermUtils.makeTermIdFromTermName(`${this.props.subscription.quarter} ${this.props.subscription.year}`);
        let errorMessage;
        if (this.store.formData.errorMessage) {
            errorMessage = <Alert variant="danger" aria-live="polite" aria-atomic={true} dismissible>{this.store.formData.errorMessage}</Alert>
        }

        const activityName = String(`${this.props.subscription.courseCurriculumAbbr} ${this.props.subscription.courseNumber} ${this.props.subscription.activityCode}`);
        const activityCode = activityName.replace(/\s+/g, '-').toLowerCase();

        const updateDisabled = this.store.isUpdateDisabled();
        const updateReasonId = `update-reason-${activityCode}`;

        let endpointInputs = profileStore.getEndpoints().map((endpoint, i) => {
            return (
                <Col xs={12} md={6} key={i}>
                    <EndpointCheckbox
                        termId={termId}
                        activityCode={activityCode}
                        endpoint={endpoint}
                        onChange={(e) => this.updateProtocol(e)}
                        disabled={!profileStore.hasEndpoint(endpoint.Protocol) || isPending}
                        checked={this.store.formData[endpoint.Protocol]}
                    />
                </Col>
            );
        });

        let updateButton =
                <Button
                    variant="primary"
                    type="submit"
                    className={classnames({"disabled": updateDisabled})}
                    aria-disabled={updateDisabled}
                    aria-describedby={updateDisabled ? updateReasonId : undefined}>
                    Update
                </Button>;
        if (isPending) {
            updateButton =
                <Button
                    variant="primary"
                    disabled>
                    <Spinner animation="border" size="sm" className="me-2 align-middle" aria-hidden="true"/>
                    <span className="align-middle">Update</span>
                </Button>;
        }

        return (
            <Form onSubmit={this.handleUpdateNotification}>
                <Card border="border">
                    <Card.Body>
                    {this.props.children}
                    </Card.Body>
                </Card>
                <fieldset>
                    <legend className="sr-only">Notification Type for {activityName}</legend>
                    <Row className="my-4 mx-0 gap-3 gap-md-0">
                        {endpointInputs}
                    </Row>
                </fieldset>
                {updateDisabled && (
                    <div id={updateReasonId} className="alert alert-warning d-inline-block mb-0">
                        Select at least one notification type before updating.
                    </div>
                )}
                <ButtonToolbar className="mt-3 pt-3 justify-content-end">
                    <Button
                        variant="secondary"
                        onClick={(e) => this.props.closeForm(e)}>
                        Close
                    </Button>
                    {updateButton}
                </ButtonToolbar>
                {errorMessage}
            </Form>
        );
    }
}

SubscriptionForm.propTypes = {
    closeForm: PropTypes.func.isRequired,
    subscription: PropTypes.object.isRequired
}

export default observer(SubscriptionForm);
